/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN PROFIT & LOSS API
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   ✅ BASE CONFIG
============================================================= */
const BASE = "/tournament";

const ENDPOINTS = {
  PROFIT_LOSS: `${BASE}/profit-loss.php`,
};

/* =============================================================
   ✅ RESPONSE HANDLER (CONSISTENT)
============================================================= */
const handleResponse = (res, fallbackMessage) => {
  // Updated to handle boolean status (res.status === true or truthy string values)
  if (!res || res.status !== true) {
    return {
      success: false,
      message: res?.message || fallbackMessage,
      data: [],
      summary: {},
    };
  }

  return {
    success: true,
    message: res.message || "Success",
    data: Array.isArray(res.data) ? res.data : [],
    summary: res.summary || {},
  };
};

/* =============================================================
   ✅ ERROR HANDLER
============================================================= */
const handleError = (error, label) => {
  console.error(`❌ ${label} Error:`, error);

  return {
    success: false,
    message: error?.message || "Unexpected error occurred",
    data: [],
    summary: {},
  };
};

/* =============================================================
   📊 GET PROFIT & LOSS
============================================================= */
export const getProfitLoss = async (
  { tournament_id } = {},
  options = {}
) => {
  try {
    if (!tournament_id) {
      return {
        success: false,
        message: "Tournament ID is required",
        data: [],
        summary: {},
      };
    }

    const res = await apiCall(
      "GET",
      ENDPOINTS.PROFIT_LOSS,
      null,
      "Fetch Profit & Loss",
      {
        params: {
          tournament_id,
        },
        ...options,
      }
    );

    return handleResponse(res, "Failed to fetch profit & loss");
  } catch (error) {
    return handleError(error, "Fetch Profit & Loss");
  }
};